import { all } from "redux-saga/effects";
import {
    getSignedUrlWatcher,
    glossaryDropDownWatcher, htmlFileTranslateWatcher, recentTranslationsWatcher, recentViewWatcher, translateBatchDocWatcher, translateBatchMoreThan20DocWatcher,
    translateBatchViewDocWatcher, translateDocWatcher, uploadFileWatcher, viewDocWatcher
} from "./translateSaga";
import { emailLoginWorkerWatcher, emailPasswordLoginWatcher, emailSignupWorkerWatcher, forgotPasswordWorkerWatcher, googleAuthWorkerWatcher, googleLoginWorkerWatcher, resetPasswordWorkerWatcher, verifyTokenWatcher } from "./authSaga";
import {
    portalCreateWatcher, portalDeleteWatcher, portalListWatcher, portalViewWatcher, usersDropDownWatcher,
    portalEditWatcher, addResourcePortalWatcher, addUserPortalWatcher, removeUserPortalWatcher, glossaryListPortalWatcher,
    removeGlossaryPortalWatcher
} from "./portalSaga";
import { getLoginReportWatcher, portalDropDownWatcher, removePortalWatcher, userDeleteWatcher, userEditWatcher, userInviteWatcher, userListWatcher, userViewWatcher } from "./userSaga"
import { translationJobListWatcher } from "./translationJobSaga";
import { assignPortalGlossaryWatcher, createGlossaryWatcher, deleteGlossaryWatcher, listGlossaryWatcher, portalsDropDownWatcher, uploadCsvFileWatcher } from "./resourceSaga";
import { companyRegisterWatcher } from "./companySaga";
import { companyEditWatcher, companyViewWatcher } from "./settingsSaga";
import { logsListWatcher } from "./logsSaga";

export default function* rootSaga() {
    yield all([
        uploadFileWatcher(),
        translateDocWatcher(),
        translateBatchDocWatcher(),
        translateBatchViewDocWatcher(),
        viewDocWatcher(),
        glossaryDropDownWatcher(),
        recentTranslationsWatcher(),
        recentViewWatcher(),
        translateBatchMoreThan20DocWatcher(),
        getSignedUrlWatcher(),
        htmlFileTranslateWatcher(),

        googleLoginWorkerWatcher(),
        emailLoginWorkerWatcher(),
        emailSignupWorkerWatcher(),
        forgotPasswordWorkerWatcher(),
        resetPasswordWorkerWatcher(),

        portalListWatcher(),
        portalViewWatcher(),
        usersDropDownWatcher(),
        portalCreateWatcher(),
        portalDeleteWatcher(),
        portalEditWatcher(),
        glossaryListPortalWatcher(),
        addResourcePortalWatcher(),
        addUserPortalWatcher(),
        removeUserPortalWatcher(),
        removeGlossaryPortalWatcher(),

        userListWatcher(),
        userInviteWatcher(),
        portalDropDownWatcher(),
        userViewWatcher(),
        userEditWatcher(),
        userDeleteWatcher(),
        getLoginReportWatcher(),
        removePortalWatcher(),

        translationJobListWatcher(),

        uploadCsvFileWatcher(),
        createGlossaryWatcher(),
        listGlossaryWatcher(),
        deleteGlossaryWatcher(),
        assignPortalGlossaryWatcher(),
        portalsDropDownWatcher(),

        companyRegisterWatcher(),

        companyViewWatcher(),
        companyEditWatcher(),

        verifyTokenWatcher(),
        googleAuthWorkerWatcher(),
        emailPasswordLoginWatcher(),

        logsListWatcher(),

        /**Watcher functions to be added here */
    ]);
}
